import type { VFC } from 'react';
import { Popconfirm as PopconfirmAntd, type PopconfirmProps } from 'antd';

export const Popconfirm: VFC<PopconfirmProps> = props => <PopconfirmAntd {...props} />;
